import React from 'react';
import { motion } from 'motion/react';
import { Sun, Moon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTheme } from './ThemeContext';

export default function Header() {
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="sticky top-0 z-50 w-full border-b border-black/5 dark:border-white/5 bg-[#FAF9F6]/80 dark:bg-slate-950/80 backdrop-blur-md transition-colors duration-300"
    >
      <div className="mx-auto flex h-20 max-w-[90rem] items-center justify-between px-6 lg:px-12">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-xl transition-transform group-hover:scale-105 shadow-sm">
            <picture>
              <source srcSet="/logo.webp" type="image/webp" />
              <img src="/logo.png" alt="RingTail Press Logo" className="h-full w-full object-cover" />
            </picture>
          </div>
          <span className="font-serif text-2xl font-semibold tracking-tight text-slate-900 dark:text-slate-50 transition-colors duration-300">
            RingTail Press
          </span>
        </Link>
        
        <div className="flex items-center gap-6">
          <nav className="hidden md:flex items-center gap-8">
            <Link to="/#books" className="text-sm font-medium text-slate-600 dark:text-slate-300 transition-colors duration-300 hover:text-slate-900 dark:hover:text-white">Books</Link>
            <Link to="/#apps" className="text-sm font-medium text-slate-600 dark:text-slate-300 transition-colors duration-300 hover:text-slate-900 dark:hover:text-white">Apps</Link>
            <Link to="/#contact" className="text-sm font-medium text-slate-600 dark:text-slate-300 transition-colors duration-300 hover:text-slate-900 dark:hover:text-white">Contact</Link>
          </nav>

          <button
            onClick={toggleTheme}
            id="global-theme-toggle"
            className="group flex h-10 w-10 items-center justify-center rounded-xl border border-black/5 dark:border-white/10 bg-black/5 dark:bg-white/5 text-slate-700 dark:text-slate-300 transition-all duration-300 hover:bg-black/10 dark:hover:bg-white/10 hover:scale-105 active:scale-95"
            aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
          >
            {theme === 'light' ? (
              <Moon className="h-4 w-4 transition-transform group-hover:rotate-12" />
            ) : (
              <Sun className="h-4 w-4 text-amber-400 transition-transform group-hover:rotate-90 duration-500" />
            )}
          </button>
        </div>
      </div>
    </motion.header>
  );
}

